import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="loader-content" style={{ height: '100vh', justifyContent: 'center' }}>
        <div className="loader-circle"></div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/v3-x-command-root/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
